// Module
var code = "<div class=\"vui-tabs tw-w-full tw-flex tw-flex-row\" ng-transclude></div>\n";
// Exports
module.exports = code;